import { flexColumn, warningIconBox } from '$styles/common.css'
import { Key } from 'lucide-react'
import { FC } from 'react'
import {
  generatePublicKeyContainer,
  generatePublicKeyFooter,
  generatePublicKeyMain
} from './styles.css'
import { Button, Spinner } from '@genie-fintech/ui/components'
import { body, title } from '@genie-fintech/ui/style/typography'
import { themeVars } from '@genie-fintech/ui/style/theme'

const { colors } = themeVars

interface IProps {
  onGenerate: VoidFunction
  onNotNow: VoidFunction
  loading: boolean
}

const GeneratePublicKeyPrompt: FC<IProps> = ({
  onGenerate,
  onNotNow,
  loading
}) => {
  return (
    <article className={generatePublicKeyContainer}>
      <main className={generatePublicKeyMain}>
        <span className={warningIconBox}>
          <Key size={20} />
        </span>

        <article className={flexColumn} style={{ gap: 4 }}>
          <p className={title.four}>GENERATE PUBLIC KEY</p>
          <p className={body.three} style={{ color: colors.neutral[70] }}>
            A secure public key to share safely without exposing private data.
          </p>
        </article>
      </main>

      <footer className={generatePublicKeyFooter}>
        <Button
          styleVariants={{ size: 'small', kind: 'neutral', type: 'outlined' }}
          onClick={onGenerate}
          disabled={loading}
        >
          {loading && <Spinner />}
          Generate
        </Button>

        <Button
          styleVariants={{ size: 'small' }}
          onClick={onNotNow}
          disabled={loading}
        >
          Not Now
        </Button>
      </footer>
    </article>
  )
}

export default GeneratePublicKeyPrompt
